import { useState, useEffect } from 'react';

function TemplateFieds({ mapper, items = [] }) {
  const [selected, setSelected] = useState({});

  const onClick = item => {
    mapper.show(item.id);
    setSelected(item);
  };

  const handleSelectedItemChange = e => {
    setSelected(e.detail);
  };

  useEffect(() => {
    const template_fields = document.querySelector('#template-fields-input');
    template_fields.addEventListener('OCRItemSelected', handleSelectedItemChange, true);
  }, []);

  const data = items.map(item => {
    const active_class = selected.id === item.id ? 'active' : '';
    return (
      <li key={item.id} className={`list-group-item d-flex align-items-start clickable ${active_class}`} onClick={onClick.bind(this, item)}>
        <div className="badge me-3" style={{ backgroundColor: item.fill, color: item.fill, border: '1px solid #fafafa' }}>
          10
        </div>
        <div>{item.name}</div>
      </li>
    );
  });
  return (
    <div>
      <ol className="list-group">{data}</ol>
      <input type="hidden" id="template-fields-input" />
    </div>
  );
}

export default TemplateFieds;
